import { render, staticRenderFns } from "./card_cart_item.vue?vue&type=template&id=20861996&scoped=true"
import script from "./card_cart_item.vue?vue&type=script&lang=js"
export * from "./card_cart_item.vue?vue&type=script&lang=js"
import style0 from "./card_cart_item.vue?vue&type=style&index=0&id=20861996&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20861996",
  null
  
)

export default component.exports